import { getApiBaseUrl } from '../utils/config';

/**
 * 매장 관리자 로그인 응답
 * 백엔드 POST /api/licenses/login 은 { success, data } 봉투를 쓰지 않고
 * 아래 형태를 그대로 반환한다.
 */
export interface LoginCredentialsResponse {
  valid: boolean;
  reason?: string;
  storeId?: string;
  licenseKey?: string;
  role?: 'OWNER' | 'MEMBER';
  memberId?: string;
  memberName?: string;
  loginId?: string;
}

/**
 * 아이디/비밀번호로 매장 로그인
 * - admin 의 loginWithCredentials 와 동일한 엔드포인트 사용
 */
export async function loginWithCredentials(
  loginId: string,
  password: string,
): Promise<LoginCredentialsResponse> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/licenses/login`;

  let response: Response;
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ loginId, password }),
    });
  } catch {
    throw new Error('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
  }

  let json: LoginCredentialsResponse;
  try {
    json = (await response.json()) as LoginCredentialsResponse;
  } catch {
    throw new Error('서버 응답을 처리할 수 없습니다.');
  }

  return json;
}
